// Aperçu des documents (03/10, accord de Louka). Les documents des dossiers (importés du RAG d'une app,
// ou déposés) et les citations du chat pointent vers un fichier Dust du workspace :
// « <base>/api/w/<workspace>/files/fil_… ». On en tire l'identifiant pour ouvrir l'aperçu de Dust
// (panneau de la conversation, ou tiroir dans un dossier) au lieu d'un nouvel onglet.
import { isFilePreviewableContentType } from "@app/types/file_preview";
import { contentTypeFromFileName } from "@app/types/files";

const FICHIER_DUST =
  /\/api\/w\/([A-Za-z0-9_-]+)\/files\/(fil_[A-Za-z0-9]+)(?:[/?#]|$)/;

/** Identifiant du fichier Dust visé par le lien, s'il appartient au workspace ; sinon null. */
export function fichierDustDuLien(
  lien: string | null | undefined,
  workspaceId: string
): string | null {
  if (typeof lien !== "string" || lien === "") {
    return null;
  }
  const m = FICHIER_DUST.exec(lien);
  return m && m[1] === workspaceId ? m[2] : null;
}

/**
 * Aperçu en deux onglets (05/10) : identifiant du fichier qu'une source cite. Celui qu'elle porte,
 * sinon celui de son lien quand il vise un fichier du workspace ; null pour une source externe.
 */
export function fichierDeLaCitation(
  citation: { fileId?: string | null; sourceUrl?: string | null },
  workspaceId: string | null | undefined
): string | null {
  if (citation.fileId) {
    return citation.fileId;
  }
  return workspaceId
    ? fichierDustDuLien(citation.sourceUrl, workspaceId)
    : null;
}

/**
 * Aperçu des citations de recherche (22/10, demande de Louka) : une source tirée d'une recherche
 * documentaire porte le type interne du résultat (« application/vnd.dust.tool-output.… »), pas celui
 * du fichier. Jugé non prévisualisable, il faisait télécharger le PDF au lieu d'ouvrir le panneau.
 * On garde un vrai type tel quel ; un type interne cède la place à celui du nom, sinon à « text/plain »
 * (le panneau relit le vrai type du fichier : celui-ci ne sert qu'à autoriser l'aperçu).
 */
export function typePourApercu(contentType: string, titre: string): string {
  if (
    isFilePreviewableContentType(contentType) ||
    !contentType.startsWith("application/vnd.dust.")
  ) {
    return contentType;
  }
  return contentTypeFromFileName(titre) ?? "text/plain";
}
